<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
  >
    <b-form-group
      :label="$t('Возраст донора')"
      label-for="age"
      :label-cols="labelCols"
    >
      <b-row id="age">
        <b-col cols="4" class="small-padding">
          <b-form-input
            type="number"
            id="age-from"
            placeholder="от"
            name="age-from"
            :min="18"
            :max="ageTo"
            v-model="ageFrom"
            @input="inputHandler"
          ></b-form-input>
        </b-col>
        <b-col cols="4" class="small-padding">
          <b-form-input
            type="number"
            id="age-to"
            placeholder="до"
            name="age-to"
            :max="65"
            :min="ageFrom"
            v-model="ageTo"
            @input="inputHandler"
          ></b-form-input>
        </b-col>
        <b-col class="col-form-label" cols="4"><b>{{ $t('лет') }}</b></b-col>
      </b-row>
    </b-form-group>
  </b-col>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'filter-select',
  components: { Multiselect },
  props: ['cols', 'ageFrom', 'ageTo', 'labelCols'],
  methods: {
    inputHandler() {
      this.$emit('input', { ageFrom: this.ageFrom, ageTo: this.ageTo });
    },
  },
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
};
</script>

<style lang="scss">
@import '../../../css/vue-multiselect-bootstrap.scss';

legend {
  font-weight: bold;
}

.small-padding {
  padding-right: 0px;
  padding-left: 5px;
}
</style>
